module.exports = __webpack_public_path__ + "static/media/contest2025_third_place_profileImage_small.e7aaacb9.jpeg";